<template>
  <div class="giris">

    <a href="https://www.fabsis.com.tr" class="logo tr"></a> <!--:class="$t('Root.1')"-->
    <router-view></router-view>
    <div class="footer">
    </div>
    <div class="after">
      <a class="logo tr" href="https://www.fabsis.com.tr">
      </a>
      <el-tag
        style="position:relative;">
        <b>Paylaşım</b> Otomasyonu
      </el-tag>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      Proje: 'aidat'
    }
  },

  created() {

    //if (!localStorage.getItem('_aiLocale')) localStorage.setItem('_aiLocale', 'tr');
    //if (window.location.host.split('.')[1]) localStorage.setItem('_aiProje', window.location.host.split('.')[1]);
    //if (!localStorage.getItem('_aiProje')) localStorage.setItem('_aiProje', 'aidat');
    //this.Proje = localStorage.getItem('_aiProje');

  },
  methods: {
    /*
    setLocale(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem('_aiLocale', locale);
      document.title = 'Aidatım | Yeni Nesil Yönetici Asistanı';
    }
     */
  }
}
</script>
<style scoped>
@import '../../assets/css/v10.giris.css';

.cls-1 {
  fill: red;
}

.cls-2 {
  fill: black;
}
</style>



// WEBPACK FOOTER //
// src/pages/Giris/_route.vue